
import React from 'react';
import NavLink from './NavLink';
import { ChevronsRight } from 'lucide-react';
import { useLanguage } from '@/hooks/useLanguage';
import { useTranslation } from '@/lib/i18n';

interface NavMenuItemsProps {
  isHomePage: boolean;
  isScrolled: boolean;
}

const NavMenuItems: React.FC<NavMenuItemsProps> = ({ isHomePage, isScrolled }) => {
  const { language } = useLanguage();
  const { t } = useTranslation(language);
  
  if (isHomePage) {
    return (
      <>
        <li className="group relative">
          <NavLink href="#platform" isScrolled={isScrolled} isHomePage={isHomePage} className="flex items-center gap-1 text-gray-700 hover:text-node-copper transition-all duration-200 hover:bg-gray-50 rounded-md px-2 py-1">
            <span>Plateforme</span>
            <ChevronsRight size={14} className="opacity-0 group-hover:opacity-100 transition-all duration-200 -ml-1 group-hover:ml-0" />
          </NavLink>
        </li>
        <li className="group relative">
          <NavLink href="#vision" isScrolled={isScrolled} isHomePage={isHomePage} className="flex items-center gap-1 text-gray-700 hover:text-node-copper transition-all duration-200 hover:bg-gray-50 rounded-md px-2 py-1">
            <span>{t('vision')}</span>
            <ChevronsRight size={14} className="opacity-0 group-hover:opacity-100 transition-all duration-200 -ml-1 group-hover:ml-0" />
          </NavLink>
        </li>
        <li className="group relative">
          <NavLink href="#join" isScrolled={isScrolled} isHomePage={isHomePage} className="flex items-center gap-1 text-gray-700 hover:text-node-copper transition-all duration-200 hover:bg-gray-50 rounded-md px-2 py-1">
            <span>Rejoindre</span>
            <ChevronsRight size={14} className="opacity-0 group-hover:opacity-100 transition-all duration-200 -ml-1 group-hover:ml-0" />
          </NavLink>
        </li>
        <li className="group relative">
          <NavLink to="/formation" isPage isScrolled={isScrolled} isHomePage={isHomePage} className="flex items-center gap-1 text-gray-700 hover:text-node-copper transition-all duration-200 hover:bg-gray-50 rounded-md px-2 py-1">
            <span>Formation</span>
            <ChevronsRight size={14} className="opacity-0 group-hover:opacity-100 transition-all duration-200 -ml-1 group-hover:ml-0" />
          </NavLink>
        </li>
        <li className="group relative">
          <NavLink to="/business" isPage isScrolled={isScrolled} isHomePage={isHomePage} className="flex items-center gap-1 text-gray-700 hover:text-node-copper transition-all duration-200 hover:bg-gray-50 rounded-md px-2 py-1">
            <span>Business</span>
            <ChevronsRight size={14} className="opacity-0 group-hover:opacity-100 transition-all duration-200 -ml-1 group-hover:ml-0" />
          </NavLink>
        </li>
        <li className="group relative">
          <NavLink to="/deals" isPage isScrolled={isScrolled} isHomePage={isHomePage} className="flex items-center gap-1 text-gray-700 hover:text-node-copper transition-all duration-200 hover:bg-gray-50 rounded-md px-2 py-1">
            <span>Deals & Partenariats</span>
            <ChevronsRight size={14} className="opacity-0 group-hover:opacity-100 transition-all duration-200 -ml-1 group-hover:ml-0" />
          </NavLink>
        </li>
        <li className="group relative">
          <NavLink to="/international" isPage isScrolled={isScrolled} isHomePage={isHomePage} className="flex items-center gap-1 text-gray-700 hover:text-node-copper transition-all duration-200 hover:bg-gray-50 rounded-md px-2 py-1">
            <span>International</span>
            <ChevronsRight size={14} className="opacity-0 group-hover:opacity-100 transition-all duration-200 -ml-1 group-hover:ml-0" />
          </NavLink>
        </li>
      </>
    );
  }
  
  return (
    <>
      <li className="group relative">
        <NavLink to="/#platform" isPage isScrolled={isScrolled} isHomePage={isHomePage} className="flex items-center gap-1 text-gray-700 hover:text-node-copper transition-all duration-200 hover:bg-gray-50 rounded-md px-2 py-1">
          <span>Plateforme</span>
          <ChevronsRight size={14} className="opacity-0 group-hover:opacity-100 transition-all duration-200 -ml-1 group-hover:ml-0" />
        </NavLink>
      </li>
      <li className="group relative">
        <NavLink to="/#vision" isPage isScrolled={isScrolled} isHomePage={isHomePage} className="flex items-center gap-1 text-gray-700 hover:text-node-copper transition-all duration-200 hover:bg-gray-50 rounded-md px-2 py-1">
          <span>{t('vision')}</span>
          <ChevronsRight size={14} className="opacity-0 group-hover:opacity-100 transition-all duration-200 -ml-1 group-hover:ml-0" />
        </NavLink>
      </li>
      <li className="group relative">
        <NavLink to="/#join" isPage isScrolled={isScrolled} isHomePage={isHomePage} className="flex items-center gap-1 text-gray-700 hover:text-node-copper transition-all duration-200 hover:bg-gray-50 rounded-md px-2 py-1">
          <span>Rejoindre</span>
          <ChevronsRight size={14} className="opacity-0 group-hover:opacity-100 transition-all duration-200 -ml-1 group-hover:ml-0" />
        </NavLink>
      </li>
      <li className="group relative">
        <NavLink to="/formation" isPage isScrolled={isScrolled} isHomePage={isHomePage} className="flex items-center gap-1 text-gray-700 hover:text-node-copper transition-all duration-200 hover:bg-gray-50 rounded-md px-2 py-1">
          <span>Formation</span>
          <ChevronsRight size={14} className="opacity-0 group-hover:opacity-100 transition-all duration-200 -ml-1 group-hover:ml-0" />
        </NavLink>
      </li>
      <li className="group relative">
        <NavLink to="/business" isPage isScrolled={isScrolled} isHomePage={isHomePage} className="flex items-center gap-1 text-gray-700 hover:text-node-copper transition-all duration-200 hover:bg-gray-50 rounded-md px-2 py-1">
          <span>Business</span>
          <ChevronsRight size={14} className="opacity-0 group-hover:opacity-100 transition-all duration-200 -ml-1 group-hover:ml-0" />
        </NavLink>
      </li>
      <li className="group relative">
        <NavLink to="/deals" isPage isScrolled={isScrolled} isHomePage={isHomePage} className="flex items-center gap-1 text-gray-700 hover:text-node-copper transition-all duration-200 hover:bg-gray-50 rounded-md px-2 py-1">
          <span>Deals & Partenariats</span>
          <ChevronsRight size={14} className="opacity-0 group-hover:opacity-100 transition-all duration-200 -ml-1 group-hover:ml-0" />
        </NavLink>
      </li>
      <li className="group relative">
        <NavLink to="/international" isPage isScrolled={isScrolled} isHomePage={isHomePage} className="flex items-center gap-1 text-gray-700 hover:text-node-copper transition-all duration-200 hover:bg-gray-50 rounded-md px-2 py-1">
          <span>International</span>
          <ChevronsRight size={14} className="opacity-0 group-hover:opacity-100 transition-all duration-200 -ml-1 group-hover:ml-0" />
        </NavLink>
      </li>
    </>
  );
};

export default NavMenuItems;
